import { render, staticRenderFns } from "./SharedConversationsView.vue?vue&type=template&id=b44db25a&scoped=true"
import script from "./SharedConversationsView.vue?vue&type=script&lang=js"
export * from "./SharedConversationsView.vue?vue&type=script&lang=js"
import style0 from "./SharedConversationsView.vue?vue&type=style&index=0&id=b44db25a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44db25a",
  null
  
)

export default component.exports